import { createRoot } from 'react-dom/client';
import { App } from 'app';
import { createGlobalStyle } from 'styled-components';

// bodyタグにcss適用
const GlobalStyle = createGlobalStyle`
  body, textarea {
    margin: 0;
    font-family: 'Yu Gothic UI', 'Segoe UI', 'Helvetica Neue', Arial,
      'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Meiryo, sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <>
    <GlobalStyle />
    <App />
  </>
);
